let referToken;

export const setReferToken = (token) => {
  referToken = token;
};

export const getReferToken = () => referToken;
